import { Button } from 'component/Button'
import { Gap, Space } from 'component/Space'
import { Typo } from 'component/Typo'
import { Vertical } from 'component/Vertical'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'
import { BasicFullCameraPanel } from 'page/ProfileScreen/BasicSelfiesPanel/BasicFullCameraPanel'
import { FullbodyExamples } from 'page/ProfileScreen/BasicSelfiesPanel/FullbodyExamples'
import { FullbodyPhoto } from 'page/ProfileScreen/BasicSelfiesPanel/FullbodyPhoto'
import { UploadQr } from 'page/ProfileScreen/UploadQrModal/UploadQr'
import { controller } from 'store/controller'
import { opt } from 'store/opt'
import { getBasicFirstStep, getBasicStepForType } from 'store/profile/BasicForm'
import { store } from 'store/store'

export const FullbodyStep = observer(() => {
  const { userPhoto } = store.profile.common

  // Если сюда попали после сброса уже загруженного фото, «Отмена» возвращает его,
  // а не отправляет на выбор типа профиля.
  const onCancel = useLatestCallback(() => {
    if (store.profile.common.restoreUserPhoto()) return
    const { basic, type } = store.profile
    basic.step = basic.done ? getBasicStepForType(type) : getBasicFirstStep()
  })

  // Мерки для фото в полный рост не нужны — сразу запускаем генерацию.
  const onContinue = useLatestCallback(async () => {
    await controller.generateBasic()
  })

  // Фото приезжает с телефона: как только оно появилось, показываем его на панели.
  const onDone = useLatestCallback(() => {
    void store.identities.update()
  })

  if (userPhoto.url) return <FullbodyPhoto onContinue={onContinue} />

  if (opt.sochi) {
    return (
      <Vertical>
        <Typo size={32} medium upper center>
          {i18n('UploadFullbodyPhoto')}
        </Typo>
        <Gap height={42} />
        <BasicFullCameraPanel />
      </Vertical>
    )
  }

  return (
    <Vertical>
      <Typo size={32} medium upper center>
        {i18n('UploadFullbodyPhoto')}
      </Typo>
      <Gap height={42} />
      <UploadQr size={600} photo="full" onDone={onDone} />
      <Gap height={24} />
      <Typo size={24} secondary center pre>
        {i18n('PointYourPhoneCameraToUploadFullbodyPhoto')}
      </Typo>
      <Gap height={128} />
      <Space center>
        <FullbodyExamples />
      </Space>
      <Gap height={42} />
      <Button large action={onCancel}>
        {i18n('Cancel')}
      </Button>
    </Vertical>
  )
})
